// src/pages/auth/ResetPassword.js
// Page réinitialisation mot de passe - NE PAS MODIFIER

import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const token = searchParams.get('token');

  const handleSubmit = () => {
    setError('');
    if (password.length < 6) {
      setError(t('errors.minLength').replace('{min}', '6'));
      return;
    }
    if (password !== confirmPassword) {
      setError(t('errors.passwordMismatch'));
      return;
    }
    // TODO: Appeler l'API reset-password avec token
    setDone(true);
    setTimeout(() => navigate('/login'), 2000);
  };

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      padding: '16px',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      marginBottom: '32px',
    },
    backButton: {
      background: 'none',
      border: 'none',
      color: '#FFFFFF',
      fontSize: '20px',
      cursor: 'pointer',
    },
    logoSection: { textAlign: 'center', marginBottom: '24px' },
    logoTitle: { fontSize: '24px', fontWeight: '700', color: '#FFD700' },
    form: { display: 'flex', flexDirection: 'column', gap: '16px' },
    field: { display: 'flex', flexDirection: 'column', gap: '6px' },
    label: { fontSize: '13px', fontWeight: '600', color: '#A0AEC0' },
    input: {
      padding: '14px 16px',
      backgroundColor: '#111827',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: '8px',
      color: '#FFFFFF',
      fontSize: '15px',
      outline: 'none',
    },
    button: {
      padding: '16px',
      backgroundColor: '#FFD700',
      border: 'none',
      borderRadius: '10px',
      color: '#0A0E1A',
      fontSize: '16px',
      fontWeight: '700',
      cursor: 'pointer',
      marginTop: '8px',
    },
    errorText: { fontSize: '13px', color: '#F56565', textAlign: 'center' },
    successBox: {
      padding: '24px',
      backgroundColor: 'rgba(72, 187, 120, 0.1)',
      border: '1px solid rgba(72, 187, 120, 0.3)',
      borderRadius: '12px',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
    },
    successIcon: { fontSize: '40px' },
    successText: { fontSize: '14px', color: '#48BB78' },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Réinitialiser le mot de passe | Fynho</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate('/login')}>←</button>
      </div>

      <div style={styles.logoSection}>
        <div style={styles.logoTitle}>Nouveau mot de passe</div>
      </div>

      {done ? (
        <div style={styles.successBox}>
          <div style={styles.successIcon}>✅</div>
          <div style={styles.successText}>
            Mot de passe réinitialisé ! Redirection...
          </div>
        </div>
      ) : (
        <div style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>Nouveau mot de passe</label>
            <input
              type="password"
              style={styles.input}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Confirmer le mot de passe</label>
            <input
              type="password"
              style={styles.input}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="••••••••"
            />
          </div>
          {error && <div style={styles.errorText}>{error}</div>}
          <button style={styles.button} onClick={handleSubmit}>
            Réinitialiser
          </button>
        </div>
      )}
    </div>
  );
};

export default ResetPassword;